import React from "react";
import "./Offers_Slider.css";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";

function Offers_Slider({coupon,IMG_URL}) {
  const data = [
    "/assets/Image/Homepage/offer_slider/img1.png",
    "/assets/Image/Homepage/offer_slider/img2.png",
    "/assets/Image/Homepage/offer_slider/img1.png",
  ];

  const navigate = useNavigate();

  return (
    <section className="Offers_Slider">
      <Common_Heading_Holder headingText={"Coupons"} />
      <div className="">
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          modules={[Pagination]}
          autoplay={{ delay: 300 }}
          className="common_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1.1,
            },
            600: {
              slidesPerView: 2,
            },
          }}
        >
          {coupon?.length > 0 &&
            coupon?.map((item) => {
              return (
                <SwiperSlide>
                  <div
                    className="img_holder"
                    onClick={() => {
                      navigate("/shop");
                    }}
                  >
                    <img src={IMG_URL+item?.image} className="image" />
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </section>
  );
}

export default Offers_Slider;
